<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">Additional Income/Deduction  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" >
            <b-input-group>
              <b-input-group-prepend><label>Payroll Periode</label></b-input-group-prepend>
              <vue-monthly-picker style="width:333px;" v-model="tblData.periode" dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
                <b-input-group-prepend><label class="ml-2">Project</label></b-input-group-prepend>
                <b-form-input readonly v-model="tblData.projectname" ></b-form-input>
                <b-input-group-append>
                    <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="5">          
            <b-input-group>
                <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                <b-form-input v-model="tblData.locationname" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Employee/Crew </label></b-input-group-prepend>
                <b-form-input v-model="tblData.crewname" placeholder="Name" class="mr-1"></b-form-input>
                <b-form-input v-model="tblData.crewnik" placeholder="ID Number" class="mr-2"></b-form-input>
                <b-input-group-append>
                      <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                    <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >

        <template v-slot:cell(payrolldate)="data">
          {{data.item.payrolldate | moment('MMMM YYYY')}}
        </template>
        <template v-slot:cell(jumlah)="data">
          {{data.item.jumlah | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
        <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8">
        <b-card >
          <div slot="header">Form - Additional Income/Deduction </div>
              <b-input-group>
                <b-input-group-prepend><label>Payroll Periode</label></b-input-group-prepend>
                <vue-monthly-picker style="width:333px;" v-model="frmdata.payrolldate" dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Salary Item</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.NmKompGaji" :state="!$v.frmdata.IdKompGaji.$error" style="width:45%;"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuSalaryitemShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
                  <b-form-input readonly v-model="frmdata.JenisKomp" class="ml-1"></b-form-input>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Employee/Crew</label></b-input-group-prepend>
                <b-form-input v-model="frmdata.crewinfo" readonly :state="!$v.frmdata.crewkey.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Description </label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.uraian" :state="!$v.frmdata.uraian.$error" ></b-form-input>
              </b-input-group>

              <b-row>
                <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Amount </label></b-input-group-prepend>
                      <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span> </b-input-group-prepend>
                      <my-number v-model="frmdata.NilaiKomp" :precision="2" :disabled="(frmdata.userumus==1)" :state="!$v.frmdata.NilaiKomp.$error" class="form-control text-right"></my-number>
                  </b-input-group>
                </b-col>
              </b-row>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>


    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
        <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>        
      <b-modal v-model="lkuSalaryitemShow" size="lg" :hide-footer="true" title="List of Salary Items" :centered="true" :lazy="true">
          <lku-salaryitem @click="onSelectLkuSalaryitem" ></lku-salaryitem>
      </b-modal>        

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom: 5px;
        .input-group-prepend {
          padding-bottom:2px;
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
</style>


<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import additional from "../../apis/additional";
import dropdown from "../../data/dropdown";
import lkuCrew from "../lookup/lkuCrew";
import lkuCustomer from "../lookup/lkuCustomers";
import lkuSalaryitem from '../lookup/lkuSalaryitem';

import toastr from "mini-toastr";
toastr.init();

export default {
  components: {VueMonthlyPicker,myNumber,Loading,lkuCrew,lkuCustomer,lkuSalaryitem},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            crewkey: { required },
            uraian: { required },
            IdKompGaji: { required },
            NilaiKomp : { required},
            payrolldate : { required },
        },
  }, 
  data() {
    return {
      lkuCustomerShow: false,
      lkuCrewShow:false,
      lkuSalaryitemShow:false,
      showDelConfirm: false,
      showList:true,      
      showFilter:false,
      showForm:false,
      saveEnabled:true,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      terpilih:{tablekey:''},
      monthLabels:dropdown.monthLabels,
      uanguser:'IDR',
      frmdata: {
          crewkey: '',
          uraian: '',
          IdKompGaji: '',
          NilaiKomp : '',
          payrolldate : '',
      },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        outstand: '1'
      },
    tblFields:[
          {
            key: "payrolldate",
            label: "Payroll Period",
            thStyle: "width:100px",
          },
          {
            key: "crewinfo",
            label: "Employee",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description"
          },
          {
              key: "KdKompGaji",
              label: "Salary Item Code",
              thStyle: "width:140px",
          },
          {
              key: "NmKompGaji",
              label: "Salary Item Name"
          },
          {
              key: "jumlah",
              label: "Amount",
              thStyle: "width:140px",
              thClass: "text-right",
              tdClass: "text-right"
          },
          {
              key: "JenisKomp",
              label: "Jenis",
              thStyle: "width:120px",
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
          {
            key: "projectname",
            label: "project",
            sortable: true
          },
          {
            key: "locationname",
            label: "Location",
            sortable: true
          },
        ]
    };
  },
  computed: {
      invalidFormdata() {
        this.$v.frmdata.$touch();
        return this.$v.frmdata.$invalid;
      },
  },
  methods: {
    onSelectLkuCrew: async function (_selected) {
        this.frmdata.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
        this.frmdata.crewkey = _selected.crewkey;
        this.frmdata.crewnik = _selected.crewnik;
        this.frmdata.crewname = _selected.crewname;
        this.lkuCrewShow=false;
    },
    onSelectLkuCustomer: async function (_selected) {
        this.tblData.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.tblData.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },    
    onSelectLkuSalaryitem: function(_selected){
        this.frmdata.IdKompGaji =_selected.IdKompGaji;
        this.frmdata.NmKompGaji =_selected.NmKompGaji;
        this.frmdata.KdKompGaji =_selected.KdKompGaji;
        this.frmdata.JenisKomp = _selected.JenisKomp;

        this.lkuSalaryitemShow=false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.payrolldate=moment(this.tblData.periode).format('YYYY-MM-DD'); 

      const list = await additional.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewname = '';
        this.tblData.crewnik =  '';
        this.tblData.outstand =  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.terpilih=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.terpilih) {
            this.frmdata[key] = this.terpilih[key];
        }
      this.frmdata.idlama = data.tablekey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
      if (this.saveEnabled==false) {
        return
      }
      this.saveEnabled==false;
        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "Error Info");
              this.saveEnabled==true;
        } else {
            try {
              const data={};
              for (var key in this.frmdata) {
                  data[key] = this.frmdata[key];
              }              
              data.payrolldate=moment(this.frmdata.payrolldate).startOf('month').format('YYYY-MM-DD'); 
              // data.payrolldate=moment(this.model.payrolldate).endOf('month').format('YYYY-MM-DD'); 
              await additional.save(data);
              this.saveEnabled==true;
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
      if (this.terpilih.tablekey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await additional.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }        
          }
    },
    rowClicked(record, index) {
      if (this.terpilih.tablekey==record.tablekey) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await additional.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    }, 
  }
};
</script>
